import React, { useEffect, useState, useCallback, useRef } from 'react';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import DebouncedTextArea from 'components/shared/debouncedTextArea';
import request from 'utils/request_ajax';
import { IFreeResponseProps } from './types';

export const FreeResponse = ({ data, meta }) => {
  const initialLoad = useRef(true);
  const [response, setResponse] = useState(data?.givenAnswer || '');

  const updateRemoteAnswer = useCallback(
    async value => {
      try {
        await request.postJSON(meta.saveUrl, {
          answer: value,
          question_id: data?.questionId,
        });
      } catch (error) {
        console.error(error);
      }
    },
    [data, meta],
  );

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }
    updateRemoteAnswer(response);
  }, [response, updateRemoteAnswer]);

  if (!data || !meta) return null;

  return (
    <>
      <QuestionElementPrompt
        elementHeaderClass={meta.elementHeaderClass}
        isGradable={data.isGradable}
        questionType={data.questionType}
        isPractice={data.isPractice}
        labelErrorClass={meta.labelErrorClass}
        questionSubjectClass={meta.questionSubjectClass}
        required={data.required}
        subject={data.subject}
      />

      <div className="free_response">
        <DebouncedTextArea
          id="description"
          name="description"
          disabled={data.disabled || data.readOnly}
          placeholder={t(
            'questions.question.written_response.textarea_placeholder',
          )}
          onChange={newResponse => setResponse(newResponse)}
          value={response}
        />
      </div>
    </>
  );
};

FreeResponse.propTypes = IFreeResponseProps;

export default FreeResponse;
